// /src/components/mdm/components/dataManagement/index.js
import React, { Component } from "react";

import "../../../../components/powerBI/components/report/style/style.css";
import { connect } from "react-redux";
import { addTabToNav } from "../../../../components/topLevelNav/reducers/topLevelNavReducer";
import {
  getMdmConfig,
  hydrateMdmConfig,
  removeRows,
  setMdmData,
  getActions,
  setFullLoad,
  setRefresh,
  resetInfo,
  resetError,
  setExternalFilter,
  setLoadedData,
  doSetInfoDialog,
  doSetErrorDialog,
  updateLovValues,
  updateActionRun,
  updateTableRowCount,
  clearMdmConfig,
} from "../../../../components/mdm/reducers/mdmReducer";
import { Link } from "react-router-dom";
import { cloneDeep, isObject } from "lodash";
import "../../style.css";
import axios from "axios";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { DotLoader } from "react-spinners";
import { LoadingIndicator } from "../../../../lib/loadingIndicator";
import { socket } from "../../../../routes";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select, { components } from "react-select";
import { RefreshIcon, WarningTriangleIcon } from "../../../../lib/icons";
import saveAs from "file-saver";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DMGridContainer from "./dmGridContainer";
import { reportClientError } from "../../../../lib/clientLog";
import withRouter from "../../../../hocs/withRouter";

const CustomSingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>{props.data.label.split(" (")[0]}</components.SingleValue>
);

// How long attemptPartialSaveReveal will keep re-trying an incomplete Row # result
// (see there) before giving up and revealing the modal with whatever it has.
const PARTIAL_SAVE_REVEAL_TIMEOUT_MS = 5000;

class DataManagement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modifiedRows: [],
      deletedRows: [],
      currentTable: [],
      oldData: [],
      rowData: [],
      activeIdx: 0,
      currentAppIdx: 0,
      showDeleteConfirmModal: false,
      showUnsavedChangesModal: false,
      showInvalidSave: false,
      showInfoModal: false,
      dirty: false,
      desc: "",
      info: [],
      errorMessage: "",
      showErrorModal: false,
      showPartialSaveModal: false,
      failedRows: [],
      // Row # for each failed row. Computed once the post-save refetch's data has
      // actually landed in the grid (see onRowDataReady) — not recomputed on later
      // renders.
      failedRowNumbers: {},
      partialSaveAllFailed: false,
      // "error" | "partial" | null — set whenever a save produces a failure the user
      // dismissed via handleClose, so the toolbar warning icon (see renderSecondaryNav)
      // can still offer to reopen it. Cleared on a clean save or a table switch, since
      // failedRows/errorMessage stop describing anything on screen at that point.
      lastFailureKind: null,
      // IDs of rows that failed to save, kept (and highlighted in the grid) after the
      // partial-save modal is dismissed so the user can still find them; cleared when
      // the next save attempt starts.
      highlightedRowIds: [],
      saving: false,
      runningAction: false,
      navClickedIdx: null,
      selectedQuickFilters: null,
      activeProject: null,
      activeProjectIdx: 0,
      loaded: false,
      showUploadModal: false,
      importing: false,
      primaryTable: null,
      importStatus: "",
      importErrors: [],
      showProgressModal: false,
      importId: "",
      runUpdate: false,
      loadedRows: 0,
      rowCount: 0,
      saveClearKey: 0,
      activeTableIdx: 0,
      gotActions: false,
    };
    this.agGrid = React.createRef();
    this.configAbortController = null; // Cancelled on app change/unmount to prevent stale responses polluting the store
    // Bumped on every save attempt and every table switch, so a stale async callback
    // from an earlier/superseded save (or one for a table the user has since navigated
    // away from) can recognize itself as stale and bail out instead of applying its
    // captured ids/table against whatever is on screen now. Plain instance fields, not
    // React state — nothing here is rendered directly, so they don't need to trigger
    // re-renders, and reading them is never subject to setState's stale-closure risk.
    this.saveGeneration = 0;
    this.pendingPartialSave = null; // { ids, tableIdx, generation } | null — see attemptPartialSaveReveal
    this.unmounted = false;
    this.gridReady = this.gridReady.bind(this);
    this.onRowDataReady = this.onRowDataReady.bind(this);
    this.attemptPartialSaveReveal = this.attemptPartialSaveReveal.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.setDirty = this.setDirty.bind(this);
    this.removeRows = this.removeRows.bind(this);
    this.actionRunResultHandler = this.actionRunResultHandler.bind(this);
    this.importStatusHandler = this.importStatusHandler.bind(this);
    this.handleProjectChange = this.handleProjectChange.bind(this);
    this.handleselectedFile = this.handleselectedFile.bind(this);
    this.setShowUploadModal = this.setShowUploadModal.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.getErrorCSV = this.getErrorCSV.bind(this);
    this.renderImportDataStatus = this.renderImportDataStatus.bind(this);
    this.clearQuickFiltersRef = null;
  }

  componentDidMount() {
    const { loadedData, mdmConfig, mdmApps } = this.props;
    socket.on("ActionRunResult", this.actionRunResultHandler);
    socket.on("ImportStatus", this.importStatusHandler);

    let pathInfo = this.props.location.pathname.split("/")[3]; // e.g. "123+0+1"
    if (pathInfo) {
      const table = pathInfo.split("+")[1];
      // If table is present, set local state
      if (table !== undefined) {
        let currentTableDefData;
        if (loadedData && mdmConfig[table]) {
          currentTableDefData = mdmConfig[table].data;
        }
        this.setState({
          activeTableIdx: table,
          currentTable: currentTableDefData,
        });
      } else if (mdmApps.length === 0) {
        // Apps not loaded yet; the mdmApps block below redirects to the resolved app otherwise
        setTimeout(() => this.props.navigate("/mdm/dataManagement/1+0", { replace: true }), 0);
      }
    } else if (mdmApps.length === 0) {
      // Apps not loaded yet; the mdmApps block below redirects to the resolved app otherwise
      setTimeout(() => this.props.navigate("/mdm/dataManagement/1+0+0", { replace: true }), 0);
    }

    // On initial mount, if mdmApps are available, hydrate the configuration
    if (mdmApps.length > 0) {
      const currentAppId = this.props.location.pathname.split("/")[3] ? pathInfo.split("+")[0] : mdmApps[0].ID;
      const currentTableId = this.props.location.pathname.split("/")[3] ? pathInfo.split("+")[1] : 0;
      if (!mdmApps.some((item) => String(item.ID) === String(currentAppId))) {
        // App in URL isn't available to this client; go to the first one instead of hanging
        this.props.navigate("/mdm/dataManagement/" + mdmApps[0].ID + "+0+0", { replace: true });
        return;
      }
      // Load configuration for the current app, if not already loaded
      if (this.configAbortController) this.configAbortController.abort();
      this.configAbortController = new AbortController();
      const { signal } = this.configAbortController;
      this.props.hydrateMdmConfig(currentAppId, signal);
      this.props.getMdmConfig(currentAppId, 0, signal);

      if (mdmConfig.length > 0 && mdmConfig[currentTableId]) {
        this.props.getActions(mdmConfig[currentTableId].id);
      }
      // this.props.getActions(currentAppId);

      // Optionally, add the tab to your navigation if needed
      const findIdx = mdmApps.findIndex((item) => item.ID === parseInt(currentAppId, 10));
      if (findIdx !== -1) {
        let project = this.props.location.pathname.split("+")[1] || 0;
        const targetPath = "/mdm/dataManagement/" + mdmApps[findIdx].ID + "+" + project;
        setTimeout(() => this.props.navigate(targetPath, { replace: true }), 0);
        this.props.addTabToNav({
          mdmIdx: findIdx,
          appId: mdmApps[findIdx].ID,
          title: mdmApps[findIdx].APP_NAME,
          id: mdmApps[findIdx].ID + "+0+0",
          path: "/mdm/dataManagement/" + mdmApps[findIdx].ID + "+" + project,
          type: "mdh",
          icon: "mdh",
        });
      }

      // Mark as loaded so subsequent changes will trigger componentDidUpdate
      this.setState({ loaded: true, currentAppIdx: currentAppId });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { mdmConfig, info, errorMessage, mdmApps } = this.props;
    const { activeTableIdx, currentAppIdx, gotActions } = this.state;
    // pathname may be "/mdm/dataManagement" (no segment yet) while the default redirect is pending
    let newAppIdx = (this.props.location.pathname.split("dataManagement/")[1] || "").split("+")[0] || 0;
    let pathInfo = this.props.location.pathname.split("/")[3];
    const currentTableId = pathInfo ? pathInfo.split("+")[1] || 0 : 0;
    if (mdmConfig.length > 0 && !gotActions && mdmConfig[currentTableId]) {
      this.props.getActions(mdmConfig[currentTableId].id);
      this.setState({ gotActions: true });
    }
    // If we haven't set up the app config yet and have the mdmApps list, do so:
    if (newAppIdx !== currentAppIdx && mdmApps.length > 0) {
      const findIdx = mdmApps.findIndex((item) => item.ID === parseInt(newAppIdx, 10));
      if (findIdx !== -1) {
        // Immediately clear the previous app's config so the old table list is
        // not rendered while the new app's requests are still in-flight.
        this.props.clearMdmConfig();

        // Hydrate config & fetch — abort any previous in-flight request first
        if (this.configAbortController) this.configAbortController.abort();
        this.configAbortController = new AbortController();
        const { signal } = this.configAbortController;
        this.props.hydrateMdmConfig(mdmApps[findIdx].ID, signal);
        this.props.getMdmConfig(mdmApps[findIdx].ID, 0, signal);

        if (mdmConfig.length > 0 && mdmConfig[currentTableId]) {
          this.props.getActions(mdmConfig[currentTableId].id);
        }
        // this.props.getActions(mdmApps[findIdx].ID);

        let table = this.props.location.pathname.split("+")[1] || 0;
        // On first load, push a tab into top-level nav
        this.props.navigate("/mdm/dataManagement/" + newAppIdx + "+" + table, { replace: true });
        this.props.addTabToNav({
          mdmIdx: findIdx,
          appId: mdmApps[findIdx].ID,
          title: mdmApps[findIdx].APP_NAME,
          id: mdmApps[findIdx].ID + "+0+0",
          type: "mdh",
          icon: "mdh",
          path: "/mdm/dataManagement/" + newAppIdx + "+" + table,
        });
        this.setState({ loaded: true, currentAppIdx: newAppIdx, activeTableIdx: table, selectedSecondaryTable: null });
      } else if (String(mdmApps[0].ID) !== String(newAppIdx)) {
        // The app in the URL (e.g. the hardcoded placeholder 1+0+0) isn't available to this
        // client; fall back to the first app it does have instead of hanging on load.
        this.props.navigate("/mdm/dataManagement/" + mdmApps[0].ID + "+0+0", { replace: true });
      }
    }

    // If the Redux store has new hydrated MDM config, update our local state if needed
    if (prevProps.mdmConfig !== this.props.mdmConfig) {
      if (mdmConfig[activeTableIdx] && mdmConfig[activeTableIdx].data) {
        this.setState({ currentTable: mdmConfig[activeTableIdx].data });
      }
    }

    // If we just got new info or errors from Redux, show them:
    if (info !== "") {
      this.props.resetInfo();
      toast.success(info);
    }
    if (errorMessage !== "") {
      this.props.resetError();
      this.setState({ showErrorModal: true, errorMessage, lastFailureKind: "error" });
    }
  }

  componentWillUnmount() {
    this.unmounted = true;

    // Abort any in-flight config request so its response doesn't dispatch stale
    // data into the shared Redux store after this app context is gone.
    if (this.configAbortController) this.configAbortController.abort();

    // Clear out data states
    this.props.setLoadedData(false);

    socket.off("ActionRunResult", this.actionRunResultHandler);
    socket.off("ImportStatus", this.importStatusHandler);
  }

  /** Socket event handler for when an action completes */
  actionRunResultHandler(data) {
    const { mdmConfig } = this.props;
    const { activeTableIdx, selectedAction } = this.state;
    const msgData = data.result;
    let message = this.renderInfoMessage(msgData);
    console.log(msgData);
    if (typeof message === "string" && (message.includes("ERROR") || message.includes("Error"))) {
      toast.error(message);
    } else {
      toast.success(message);
    }

    if (selectedAction) {
      this.props.updateActionRun(selectedAction.id, data.lastRunTime, data.currentUser);
    }

    // Invalidate & refetch the relevant table data with React Query
    const queryClient = this.props.queryClient;
    queryClient.invalidateQueries({
      queryKey: ["mdmData"],
      exact: false,
    });
    queryClient.refetchQueries({
      queryKey: ["mdmData", mdmConfig[activeTableIdx].id],
      exact: false,
      type: "active",
    });
    this.refreshLovsAfterSave();
    // this.props.getActions(mdmConfig[activeTableIdx].id);

    this.setState({
      showInfoModal: false,
      info: data,
      runningAction: false,
      primaryTable: mdmConfig[activeTableIdx].id,
    });
  }

  /** Socket event for import data updates */
  importStatusHandler(data, importObj) {
    const { mdmConfig } = this.props;
    const { activeTableIdx, runUpdate, importId } = this.state;

    // `socket` is a single shared connection (not scoped per import job), so this
    // handler can receive ImportStatus events for OTHER import runs - e.g. a job
    // queued by an earlier/unrelated import that only finishes processing later.
    // Without this check, an unrelated event's status/errors silently overwrite
    // the progress modal for the import THIS page instance actually kicked off,
    // which can show a stale "errors" result for an import that's still pending
    // or already succeeded (importId is set synchronously alongside the
    // `getImportStatus` subscribe in uploadFile(), so it's populated well before
    // any real event for this run can arrive).
    if (importId && importObj.importId !== importId) {
      return;
    }

    // If import is done, optionally refetch the data
    if (data === "complete" && runUpdate) {
      const queryClient = this.props.queryClient;
      queryClient.invalidateQueries({
        queryKey: ["mdmData", mdmConfig[activeTableIdx].id],
        exact: false,
      });
      queryClient.refetchQueries({
        queryKey: ["mdmData", mdmConfig[activeTableIdx].id],
        exact: false,
        type: "active",
      });
      this.setState({ runUpdate: false });
    }

    this.setState({
      importStatus: data,
      importErrors: importObj.error,
      importId: importObj.importId,
    });
  }
  refreshLovsAfterSave() {
    const { currentAppIdx } = this.state;
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/mdm/getLovValues`,
        { appId: currentAppIdx },
        {
          headers: { ClientToken: localStorage.getItem("clientToken") },
        },
      )
      .then((res) => {
        if (res.data.success) {
          this.props.updateLovValues(res.data.lovs);
        }
      })
      .catch((err) => {
        console.error("Failed to refresh LOVs:", err);
      });
  }
  /** Save all changed rows to server */
  saveHandler(pDeleteRows = null) {
    const { activeTableIdx, deletedRows } = this.state;
    const { mdmConfig, queryClient } = this.props;
    let usedDeletedRows = deletedRows;
    if (pDeleteRows !== null) {
      usedDeletedRows = pDeleteRows;
    }
    // Identifies this specific save attempt so the async continuation below (armed
    // only once its refetch resolves) can recognize itself as stale — superseded by a
    // later save, or for a table the user has since navigated away from — and bail
    // instead of surfacing a modal/highlight for the wrong table (row IDs aren't
    // unique across tables; see secondaryNavClickHandler).
    this.saveGeneration += 1;
    const saveGeneration = this.saveGeneration;
    const savingTableIdx = activeTableIdx;
    this.pendingPartialSave = null;
    this.setState({ saving: true, highlightedRowIds: [] });

    // Flush any in-progress cell edit before snapshotting the grid. If the user is
    // mid-edit (an editor is still open) when Save is clicked, stopEditing() forces
    // AG Grid to commit that editor's value and fire onCellValueChanged before we
    // read the grid below. dmGrid.js's onCellValueChanged handler now commits
    // crudType/updated synchronously (previously deferred via setTimeout(0), which
    // let a fast edit-then-Save beat that commit and silently no-op the save — and
    // couldn't be caught here at all for edits, like Delete-clearing a cell, that
    // never open an editor in the first place; see BIG-1706/MDH-021), so this check
    // is now purely for the still-open-editor case — the commit itself can no longer
    // race this snapshot regardless of how the edit was made.
    if (this.agGrid.current.gridApi.getEditingCells().length > 0) {
      // Log every time this race is actually hit (not just when it results in an
      // empty save) so we can tell how often users are saving fast enough to
      // trigger it, independent of whether crudType happened to already be set.
      reportClientError({
        type: "mdm-save-flushed-pending-edit",
        level: "info",
        message: "saveHandler flushed an in-progress cell edit before snapshotting the grid",
        detail: { table: mdmConfig[activeTableIdx]?.saveTable },
      });
      this.agGrid.current.gridApi.stopEditing();
    }

    // Collect all current rows from AG-Grid
    const rowData = [];
    this.agGrid.current.gridApi.forEachNode((node) => rowData.push(node.data));

    let savedRows = rowData.filter((row) => {
      if (!row.crudType || row.crudType === "empty") return false;
      return true;
    });

    // If any row is invalid, we skip saving
    let continueWithSave = true;

    // Convert each row's data to the shape your server expects
    savedRows = savedRows.map((row) => {
      let saveColumns = mdmConfig[activeTableIdx].data.filter((conf) => conf.editable === true);
      saveColumns = saveColumns.map((col) => col.field);

      // The rowData we actually send
      let rowDataEntries = Object.entries(row).filter((item) => {
        const [k] = item;
        return k === "ID" || saveColumns.includes(k);
      });

      let updateRD = (row.updated || []).reduce((obj, key) => {
        if (key.newValue === "" && key.name.includes("FK")) {
          obj[key.name] = {};
        } else if (
          key.name.includes("FK") &&
          key.newValue !== null &&
          key.newValue !== undefined &&
          key.newValue.id === undefined &&
          isObject(row[key.name])
        ) {
          key.newValue = row[key.name];
          // obj[key.name] =
        } else {
          obj[key.name] = key.newValue;
        }
        return obj;
      }, {});

      // Overwrite or unify data if needed
      rowDataEntries = rowDataEntries.map(([k, v]) => {
        if (updateRD[k] !== undefined && updateRD[k] !== null) {
          // If there's a known invalid object, skip or mark invalid
          if (updateRD[k].status === "invalid") {
            continueWithSave = false;
          }
          // If it's an FK, do your ID => name mapping, etc.
          v = updateRD[k];
        }
        // Additional logic for _FK fields
        if (k.includes("_FK") && v !== null && typeof v === "object") {
          if (v.id === undefined) {
            // Possibly find an ID for the matched name, etc.
            // ...
            v = null;
          } else {
            v = v.id;
          }
        }
        // Escape backslashes if needed
        if (typeof v === "string") {
          v = v.replace(/\\/g, "\\\\\\\\");
        }
        return [k, v];
      });

      const newObj = rowDataEntries.reduce((obj, [k, v]) => {
        obj[k] = v;
        return obj;
      }, {});

      const type = row.crudType;
      delete newObj.crudType;
      delete newObj.updated;

      return {
        id: row.ID,
        type,
        rowData: newObj,
      };
    });

    // Drop insert rows that carry no actual data (e.g. blank rows added via
    // "Add Rows" but never filled in) so they are never sent to the server. This
    // only applies to inserts — a real update can legitimately clear every one of
    // a row's (few) editable columns down to null/blank (e.g. MDH-021's
    // clear-with-Delete flow), and that's a genuine change that must still be
    // saved, not a placeholder row to discard. Deletes are added below and
    // unaffected.
    savedRows = savedRows.filter(
      (r) =>
        r.type !== "insert" ||
        Object.entries(r.rowData || {}).some(([k, v]) => k !== "ID" && v !== "" && v !== null && v !== undefined),
    );

    // Deleted rows
    usedDeletedRows.forEach((row) => {
      savedRows.push({
        id: row.rowData.ID,
        type: "delete",
        rowData: { ID: row.rowData.ID },
      });
    });

    if (!continueWithSave) {
      this.setState({ saving: false, showInvalidSave: true });
      return;
    }
    const isOnlyDelete = savedRows.every((r) => r.type === "delete");
    // Post to server
    // A 60s timeout guards against the request hanging indefinitely (e.g. the
    // server stalls waiting on a pooled Snowflake connection): without this,
    // `saving` stays true forever, the Save button stays disabled/"Running",
    // and the user gets no feedback at all — exactly the "stuck screen"
    // behavior reported in the 8/18 MDH incident.
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/mdm/saveMdmData`,
        {
          table: mdmConfig[activeTableIdx].saveTable,
          saveObj: savedRows,
        },
        { headers: { ClientToken: localStorage.getItem("clientToken") }, timeout: 60000 },
      )
      .then((response) => {
        this.setState({
          modifiedRows: [],
          oldData: [],
          dirty: false,
          saving: false,
          deletedRows: [],
        });
        if (response.data.success === false) {
          this.setState({
            showErrorModal: true,
            errorMessage: response.data.message,
            lastFailureKind: "error",
          });
        } else if (response.data.update) {
          // Partial save: some rows were saved, but the stored procedure rejected
          // others (duplicate keys, FK violations, not authorized, etc.). Notify
          // the user which rows did not save; the refetch below restores them to
          // their last-saved server values.
          const failedRows = Array.isArray(response.data.failedRows) ? response.data.failedRows : [];
          const highlightedRowIds = failedRows.map((row) => row.id).filter((id) => id !== null && id !== undefined);
          if (failedRows.length > 0) {
            // Distinguish a true partial save (some rows saved) from the case where
            // every submitted row was rejected, so the modal copy doesn't claim
            // "your changes were saved" when nothing actually did. `savedRows` has
            // already had empty placeholder rows stripped, so its length is the real
            // number of rows submitted.
            const savedCount = savedRows.length - failedRows.length;
            // Don't compute the modal's Row # column yet: the refetch below can shift
            // row positions (a successfully-saved row can move out of the placeholder
            // rows into the loaded data, a now-empty leading placeholder can drop out,
            // etc.), so a number taken from the grid as it stands right now would no
            // longer match what the user sees once that refetch lands. `this.pendingPartialSave`
            // is armed once the refetch promise below resolves (see refetchPromise.then()),
            // which is what tells attemptPartialSaveReveal it's safe to compute against the grid.
            this.setState({
              failedRows,
              partialSaveAllFailed: savedCount <= 0,
              highlightedRowIds,
              lastFailureKind: "partial",
            });
          } else {
            // Every row saved — nothing left to warn about, so drop any failure
            // left over from a previous save attempt on this table.
            this.setState({ failedRows: [], failedRowNumbers: {}, partialSaveAllFailed: false, lastFailureKind: null });
          }

          // Populated with the refetch triggered below (when one happens) so we can wait
          // for it to resolve before trusting the grid's row positions for failedRowNumbers.
          let refetchPromise = null;
          if (!isOnlyDelete) {
            this.refreshLovsAfterSave();
            queryClient.invalidateQueries({
              queryKey: ["mdmData", mdmConfig[activeTableIdx].id],
              exact: false,
            });
            refetchPromise = queryClient.refetchQueries({
              queryKey: ["mdmData", mdmConfig[activeTableIdx].id],
              exact: false,
              type: "active",
            });
            this.props.setMdmData(this.props.data, this.props.rowCount - usedDeletedRows.length, this.props.data.length);
          } else {
            // Delete-only save. Rows the server rejected still exist server-side, so subtract
            // only the deletes that actually succeeded and refetch to restore the rejected rows
            // to the grid — otherwise they vanish locally, contradicting the modal message.
            const successfulDeleteCount = usedDeletedRows.length - failedRows.length;
            if (failedRows.length > 0) {
              queryClient.invalidateQueries({
                queryKey: ["mdmData", mdmConfig[activeTableIdx].id],
                exact: false,
              });
              refetchPromise = queryClient.refetchQueries({
                queryKey: ["mdmData", mdmConfig[activeTableIdx].id],
                exact: false,
                type: "active",
              });
            }
            this.props.setMdmData(this.props.data, this.props.rowCount - successfulDeleteCount, this.props.data.length);
            this.props.updateTableRowCount(activeTableIdx, this.props.rowCount - successfulDeleteCount);
            this.setState({ saveObj: [], saveClearKey: this.state.saveClearKey + 1 });
          }

          if (failedRows.length > 0 && refetchPromise) {
            refetchPromise.then(() => {
              // The refetch promise can resolve just as react-query starts notifying its
              // own subscribers — deferring one more tick lets that notification (and the
              // Redux dispatch/re-render it triggers) land before we arm, so the grid is
              // as likely as possible to already reflect the settled data.
              setTimeout(() => {
                if (this.unmounted || this.saveGeneration !== saveGeneration || this.state.activeTableIdx !== savingTableIdx) {
                  // Superseded by a later save, or the user has since navigated to a
                  // different table — these ids/table no longer describe what's on
                  // screen (row IDs aren't unique across tables), so drop them rather
                  // than risk surfacing a modal/highlight for the wrong table.
                  return;
                }
                this.pendingPartialSave = {
                  ids: highlightedRowIds,
                  tableIdx: savingTableIdx,
                  generation: saveGeneration,
                  // Bounds how long attemptPartialSaveReveal will keep re-trying an
                  // incomplete result (see there) before giving up and showing "—"s —
                  // a row can legitimately never resolve (e.g. removed by a concurrent
                  // change), so it can't wait on a full result forever.
                  deadline: Date.now() + PARTIAL_SAVE_REVEAL_TIMEOUT_MS,
                };
                // onRowDataReady may have already fired for this refetch by the time we
                // get here, or may never fire again if nothing else changes the grid —
                // don't rely solely on a future firing that may never come; try
                // immediately, and also schedule one guaranteed final attempt right at
                // the deadline so an incomplete result still gets revealed even without
                // another onRowDataReady firing to prompt it.
                this.attemptPartialSaveReveal();
                setTimeout(() => this.attemptPartialSaveReveal(), PARTIAL_SAVE_REVEAL_TIMEOUT_MS);
              }, 0);
            });
          }

          // this.props.hydrateMdmConfig(this.state.currentAppIdx);
          // Clean up local state
          this.setState({
            saveObj: [],
            primaryTable: mdmConfig[activeTableIdx].id,
            saveClearKey: this.state.saveClearKey + 1,
          });
        } else if (response.data.message) {
          // "Nothing to save" (or similar): the server received an empty saveObj
          // and no-op'd — a fast 200 response with no `update` key. Previously
          // this fell through with zero user feedback: the spinner cleared (see
          // setState above) but nothing told the user their edit wasn't actually
          // saved, which read as "did that even do anything?" — surface it so
          // it's at least visible instead of silent. Also report it to the server
          // logs with the row/delete counts at save time, so a recurrence can be
          // correlated with what the grid actually thought it was submitting.
          reportClientError({
            type: "mdm-save-nothing-to-save",
            level: "warn",
            message: response.data.message,
            detail: {
              table: mdmConfig[activeTableIdx]?.saveTable,
              submittedRowCount: savedRows.length,
              deletedRowCount: usedDeletedRows.length,
            },
          });
          this.setState({ saveObj: [], showErrorModal: true, errorMessage: response.data.message });
        } else {
          // Full success, nothing rejected — clear any failure carried over from a
          // previous attempt so the toolbar warning icon disappears.
          this.setState({ saveObj: [], failedRows: [], failedRowNumbers: {}, partialSaveAllFailed: false, lastFailureKind: null });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ saving: false });
        if (error.response) {
          reportClientError({
            type: "mdm-save-error-response",
            message: (error.response.data && error.response.data.error) || "Save failed",
            detail: {
              table: mdmConfig[activeTableIdx]?.saveTable,
              status: error.response.status,
              submittedRowCount: savedRows.length,
            },
          });
          this.setState({
            showErrorModal: true,
            errorMessage: error.response.data.error,
            lastFailureKind: "error",
          });
        } else if (error.code === "ECONNABORTED") {
          // Request timed out client-side with no server response at all — the save
          // may or may not have gone through server-side, so tell the user to refresh
          // and check rather than silently leaving them wondering why nothing happened.
          // This is the "spinning forever" failure mode originally reported — log it
          // with full context (elapsed time, row/table info) so a recurrence is
          // visible in the server logs even though the server itself never saw the
          // request resolve.
          reportClientError({
            type: "mdm-save-client-timeout",
            message: "saveMdmData timed out client-side after 60s with no server response",
            detail: {
              table: mdmConfig[activeTableIdx]?.saveTable,
              submittedRowCount: savedRows.length,
              deletedRowCount: usedDeletedRows.length,
            },
          });
          this.setState({
            showErrorModal: true,
            errorMessage:
              "The save is taking longer than expected and may not have completed. Please refresh and check your changes before retrying.",
            lastFailureKind: "error",
          });
        } else {
          // Any other network-level failure (e.g. connection dropped) with no
          // `error.response` — previously this fell through with no user feedback.
          reportClientError({
            type: "mdm-save-network-error",
            message: (error && (error.message || error.toString())) || "Save failed due to a network error",
            detail: {
              table: mdmConfig[activeTableIdx]?.saveTable,
              submittedRowCount: savedRows.length,
            },
          });
          this.setState({
            showErrorModal: true,
            errorMessage: "Save failed due to a network error. Please check your connection and try again.",
            lastFailureKind: "error",
          });
        }
      });
  }

  /** Called when user clicks a different table from the left nav */
  secondaryNavClickHandler(item, idx, overrideDirty = false) {
    const { mdmConfig } = this.props;
    const { activeTableIdx, dirty } = this.state;

    // If the user has unsaved changes, show a modal to confirm losing them
    if (!dirty || overrideDirty) {
      // Cancel any ongoing row fetches in React-Query for the old table
      const queryClient = this.props.queryClient;
      queryClient.cancelQueries({
        queryKey: ["mdmData", mdmConfig[activeTableIdx].id],
      });

      this.props.getActions(mdmConfig[idx].id);

      this.props.setFullLoad(false);

      // Invalidates any save still waiting on its refetch to settle (see saveHandler) —
      // its ids/table no longer describe what's about to be on screen.
      this.saveGeneration += 1;
      this.pendingPartialSave = null;

      this.setState({
        currentTable: mdmConfig[idx].data,
        activeTableIdx: idx,
        desc: mdmConfig[idx].desc,
        runningAction: false,
        selectedAction: null,
        primaryTable: mdmConfig[idx].id,
        selectedSecondaryTable: null,
        saving: false,
        // Row IDs aren't unique across tables — a highlight from the previous
        // table could otherwise land on an unrelated row here. The same applies to
        // any leftover save-failure info: it describes rows on the table being left,
        // so the toolbar warning icon shouldn't carry it over either.
        highlightedRowIds: [],
        failedRows: [],
        failedRowNumbers: {},
        partialSaveAllFailed: false,
        errorMessage: "",
        lastFailureKind: null,
      });
      this.props.navigate(`/mdm/dataManagement/${this.state.currentAppIdx}+${idx}`);
    } else {
      // We do have unsaved changes
      this.setState({ showUnsavedChangesModal: true, navClickedIdx: idx });
    }
  }

  /** Called if user decides to lose unsaved changes */
  cancelHandler(runSecondaryNavClick = false) {
    const { rollBackData } = this.props;
    const { navClickedIdx } = this.state;

    this.props.setMdmData(rollBackData);
    this.props.setRefresh(true);
    this.setState({ dirty: false });

    if (runSecondaryNavClick) {
      this.secondaryNavClickHandler(null, navClickedIdx, true);
      this.setState({ showUnsavedChangesModal: false, navClickedIdx: null });
    }
  }

  handleChange(selectedOption) {
    this.setState({ selectedAction: selectedOption });
  }

  handleProjectChange(selectedOption) {
    const { activeTableIdx } = this.state;
    const { mdmConfig } = this.props;
    this.props.hydrateMdmConfig(this.state.currentAppIdx);
    this.props.getMdmConfig(this.state.currentAppIdx, selectedOption.id);
    let pathInfo = this.props.location.pathname.split("/")[3];
    const currentTableId = this.props.location.pathname.split("/")[3] ? pathInfo.split("+")[1] : 0;
    this.props.getActions(mdmConfig[currentTableId].id);

    // Just update local state
    this.setState({
      activeProject: selectedOption,
      activeProjectIdx: selectedOption.id,
    });
    // Also push route if needed
    this.props.navigate(`/mdm/dataManagement/${this.state.currentAppIdx}+${activeTableIdx}`);
  }

  handleSecondaryChange = (selectedTable) => {
    const { dirty, currentAppIdx } = this.state;
    const { mdmConfig } = this.props;
    if (!dirty) {
      this.props.navigate(`/mdm/dataManagement/${currentAppIdx}+${selectedTable.idx}`);
      this.props.getActions(selectedTable.id);

      this.props.setFullLoad(false);

      this.setState({
        currentTable: mdmConfig[selectedTable.idx].data,
        activeTableIdx: selectedTable.idx,
        selectedSecondaryTable: selectedTable,
        primaryTable: selectedTable.id,
        runningAction: false,
        saving: false,
      });
    } else {
      // We have unsaved changes
      this.props.navigate(`/mdm/dataManagement/${currentAppIdx}+${selectedTable.idx}`);
      this.setState({
        showUnsavedChangesModal: true,
        navClickedIdx: selectedTable.idx,
      });
    }
  };

  runAction() {
    const { selectedAction, activeTableIdx, currentAppIdx } = this.state;
    this.setState({ runningAction: true });

    socket.emit("runAction", {
      token: localStorage.getItem("clientToken"),
      action: selectedAction.id,
      table: this.props.mdmConfig[activeTableIdx].name,
      currentApp: currentAppIdx,
    });
  }

  handleselectedFile = (event) => {
    event.preventDefault();
    this.setState({ uploadFile: event.target.files[0] });
  };

  uploadFile() {
    const { uploadFile, activeTableIdx, currentAppIdx } = this.state;
    const { mdmConfig } = this.props;
    if (!uploadFile) return;
    this.setState({ importing: true });

    const data = new FormData();
    data.append("file", uploadFile);
    data.append("appId", currentAppIdx);
    data.append("activeIdx", activeTableIdx);
    data.append("primaryTable", mdmConfig[activeTableIdx].id);
    data.append("saveTable", mdmConfig[activeTableIdx].saveTable);
    // data.append("project", activeProject.id);

    axios
      .post(`${process.env.REACT_APP_BIGHORN_SERVER}/api/mdm/importData`, data, {
        headers: { ClientToken: localStorage.getItem("clientToken") },
      })
      .then((res) => {
        socket.emit("getImportStatus", {
          token: localStorage.getItem("clientToken"),
          importId: res.data.runId,
        });
        // We'll watch the socket event to track progress
        this.handleClose();
        this.setState({
          runUpdate: true,
          showProgressModal: true,
          importId: res.data.runId,
        });
      });
  }

  setShowUploadModal(state) {
    this.setState({ showUploadModal: state });
  }

  handleClearQuickFiltersRef = (clearFn) => {
    this.clearQuickFiltersRef = clearFn;
  };

  /** The left nav and top bar for selecting tables, actions, etc. */
  renderSecondaryNav() {
    const { mdmConfig, actions, mdmApps } = this.props;
    const { activeTableIdx, currentAppIdx, selectedAction, selectedSecondaryTable, dirty, activeProject, runningAction } =
      this.state;

    let currentApp = mdmApps.find((item) => item.ID === parseInt(currentAppIdx, 10));
    if (!currentApp) return <div />;

    let projects = currentApp.PROJECTS.map((item) => ({
      id: item.PROJECT_ID,
      label: item.PROJECT_NAME,
      value: item.PROJECT_NAME,
      batchId: item.AB_BATCH_ID,
    }));

    let primaryTables = mdmConfig.filter((item) => item.primaryTable);
    let secondaryTables = mdmConfig
      .filter((item) => !item.primaryTable)
      .map((item) => ({
        label: item.name,
        value: item.name,
        idx: item.idx,
        id: item.id,
      }));

    // Pick whichever project is active
    let currProject = activeProject || projects[0];

    // The “horizontal” nav for primary tables
    let names = primaryTables.map((conf, i) => (
      <div
        style={{ display: "flex", border: "none" }}
        key={conf.idx}
        className={parseInt(activeTableIdx, 10) === conf.idx ? "mdm-active" : ""}>
        <div className={parseInt(activeTableIdx, 10) === conf.idx ? "mdm-circle-selected" : "mdm-circle"}>{i + 1}</div>
        <Link
          onClick={() => this.secondaryNavClickHandler(null, conf.idx)}
          className={"mdm-nav-link " + (parseInt(activeTableIdx, 10) === conf.idx ? "mdm-active" : "")}
          data-testid={`mdh-table-link-${conf.idx}`}
          to={`/mdm/dataManagement/${currentAppIdx}+${conf.idx}`}>
          {conf.name}
        </Link>
      </div>
    ));
    const formattedActions = actions.map((action) => {
      // If there's no lastRunTime, only show the action label
      if (!action.lastRunTime) {
        return {
          ...action,
          label: action.label, // Only the action name
        };
      }

      // Format the lastRunTime to MM/DD/YYYY HH:MM:SS AM/PM
      const lastRunDate = new Date(action.lastRunTime);
      const formattedDate = lastRunDate.toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

      // Combine the label with lastRunBy and formatted lastRunTime
      return {
        ...action,
        label: `${action.label} (Last Run: ${formattedDate} by ${action.lastRunBy})`,
      };
    });
    // Custom styles for the react-select dropdown to make it wider
    const customStyles = {
      control: (provided) => ({
        ...provided,
        minWidth: "300px", // Increase the width of the control (input area)
      }),
      menu: (provided) => ({
        ...provided,
        width: "300px", // Increase the width of the dropdown menu
      }),
      menuList: (provided) => ({
        ...provided,
        maxHeight: "300px", // Optional: Ensure the dropdown menu doesn't get too tall
      }),
      option: (provided, state) => ({
        ...provided,
        whiteSpace: "normal", // Allow text to wrap if needed
        wordWrap: "break-word", // Ensure long emails or text wrap
        ".option-last-run": {
          color: state.isSelected ? "white" : "#666",
        },
      }),
    };

    let pathInfo = this.props.location.pathname.split("/")[3];
    const currentTableId = this.props.location.pathname.split("/")[3] ? pathInfo.split("+")[1] : 0;

    const allowImportExport = this.props.mdmConfig[currentTableId].allowImportExport;

    return (
      <div>
        <div
          style={{ display: "flex", flexDirection: "column" }}
          className="mdm-nav-buttons"
          data-testid={`mdh-secondary-nav-${currentAppIdx}`}>
          {projects.length > 1 && (
            <Select
              className="project-dropdown"
              classNamePrefix="react-select"
              placeholder="Select Project"
              value={currProject}
              onChange={this.handleProjectChange}
              options={projects}
            />
          )}

          <div style={{ display: "flex", marginLeft: "auto", alignItems: "center", marginTop: "10px" }}>
            <OverlayTrigger
              placement="top"
              rootClose
              overlay={<Tooltip id="refresh">Refresh the data table</Tooltip>}
              trigger={["hover", "focus"]}>
              <div
                className="refresh-icon"
                style={{ marginRight: "15px", cursor: "pointer" }}
                onClick={() => {
                  // Invalidate queries for the active table
                  const { queryClient, mdmConfig } = this.props;
                  if (this.clearQuickFiltersRef) {
                    this.clearQuickFiltersRef();
                  }
                  queryClient.invalidateQueries({
                    queryKey: ["mdmData", mdmConfig[activeTableIdx].id],
                    exact: false,
                  });
                  queryClient.refetchQueries({
                    queryKey: ["mdmData", mdmConfig[activeTableIdx].id],
                    exact: false,
                    type: "active",
                  });
                  this.refreshLovsAfterSave();
                  this.props.setFullLoad(false);
                  this.props.setRefresh(true);
                }}>
                <RefreshIcon color="rgba(88, 89, 91, 1)" height="20" />
              </div>
            </OverlayTrigger>
            {formattedActions.length > 0 && (
              <>
                {!runningAction ? (
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "400px" }}>
                    <div className="run-action">Run Action:</div>
                    <Select
                      className="action-dropdown"
                      classNamePrefix="react-select"
                      placeholder="Actions"
                      value={selectedAction}
                      onChange={this.handleChange}
                      options={formattedActions}
                      styles={customStyles}
                      components={{ SingleValue: CustomSingleValue }}
                      // Use formatOptionLabel to customize the display of each option
                      formatOptionLabel={(option) => (
                        <div>
                          {option.lastRunTime ? (
                            <div>
                              {option.label.split(" (")[0]}
                              <div className="option-last-run" style={{ fontSize: "0.8em" }}>
                                {`Last Run: ${new Date(option.lastRunTime).toLocaleString("en-US", {
                                  month: "2-digit",
                                  day: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                  hour12: true,
                                })} ${option.lastRunBy}`}
                              </div>
                            </div>
                          ) : (
                            <div>{option.label}</div>
                          )}
                        </div>
                      )}
                    />
                  </div>
                ) : (
                  <div className="running-action" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <DotLoader sizeUnit="px" size={15} color="black" loading />
                    <div style={{ marginLeft: "5px" }}>Running</div>
                  </div>
                )}

                {!this.state.saving ? (
                  <button
                    className={"mdm-button mdm-button-secondary run-button " + (!dirty ? "" : "disabled")}
                    onClick={() => this.runAction()}>
                    Run
                  </button>
                ) : (
                  <button className="run-button disabled">Run</button>
                )}
              </>
            )}
            {allowImportExport && (
              <button
                onClick={() => this.setShowUploadModal(true)}
                style={{ marginRight: "35px" }}
                className="mdm-button mdm-button-secondary">
                Import Data
              </button>
            )}

            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
              {this.state.lastFailureKind && (
                <OverlayTrigger
                  placement="top"
                  rootClose
                  overlay={
                    <Tooltip id="last-save-failure">
                      {this.state.lastFailureKind === "partial"
                        ? "Some rows were not saved — click to view details"
                        : "The last save failed — click to view details"}
                    </Tooltip>
                  }
                  trigger={["hover", "focus"]}>
                  <div
                    role="button"
                    aria-label="View last save failure details"
                    style={{ marginRight: "15px", cursor: "pointer", display: "flex", alignItems: "center" }}
                    onClick={() => {
                      if (this.state.lastFailureKind === "partial") {
                        this.setState({ showPartialSaveModal: true });
                      } else {
                        this.setState({ showErrorModal: true });
                      }
                    }}>
                    <WarningTriangleIcon color="#d97706" height="20px" style={{ width: "20px" }} />
                  </div>
                </OverlayTrigger>
              )}
              {!this.state.saving ? (
                !runningAction ? (
                  <button
                    className="mdm-button mdm-button-primary"
                    onClick={() => this.saveHandler()}
                    style={{ display: "flex", marginRight: "15px" }}>
                    Save
                  </button>
                ) : (
                  <button className="mdm-button mdm-button-secondary disabled" style={{ display: "flex", marginRight: "15px" }}>
                    Save
                  </button>
                )
              ) : (
                <div className="mdm-save" style={{ display: "flex", flexDirection: "row", marginRight: "15px" }}>
                  <DotLoader sizeUnit="px" size={15} color="black" loading />
                  <div style={{ marginLeft: "5px" }}>Saving</div>
                </div>
              )}

              <button className="mdm-button mdm-button-secondary" onClick={() => this.cancelHandler()}>
                Cancel
              </button>
            </div>
          </div>
          {secondaryTables.length > 0 ? (
            <div style={{ display: "flex" }}>
              <div className="dm-secondary-nav-cont">{names}</div>
              <div style={{ marginLeft: "auto" }}>
                <Select
                  className="reference-tables"
                  classNamePrefix="react-select"
                  placeholder="Reference Tables"
                  value={selectedSecondaryTable}
                  onChange={this.handleSecondaryChange}
                  options={secondaryTables}
                />
              </div>
            </div>
          ) : (
            <div style={{ display: "flex" }}>
              <div className="dm-secondary-nav-cont">{names}</div>
            </div>
          )}
        </div>

        <div>{this.state.desc}</div>
      </div>
    );
  }

  removeRows(rows) {
    const { deletedRows } = this.state;
    let dRows = cloneDeep(deletedRows);

    rows.forEach((row) => {
      dRows.push({
        type: "delete",
        idx: row.rowId,
        changedColumns: Object.keys(row.data),
        oldData: row.data,
        rowData: row.data,
      });
    });

    rows.forEach((row) => {
      if (row.rowId < this.props.data.length - 1) {
        dRows = dRows.map((mRow) => {
          if (mRow.idx >= row.rowId && mRow.type !== "delete") {
            mRow.idx = mRow.idx - 1;
          }
          return mRow;
        });
      }
    });

    this.props.removeRows(rows);

    // this.props.setRefresh(true);
    this.setState({ deletedRows: dRows, dirty: true });
    this.saveHandler(dRows);
    this.handleClose();
  }

  handleClose = () => {
    const { activeTableIdx, currentAppIdx } = this.state;
    let idx = parseInt(activeTableIdx, 10);
    this.props.navigate(`/mdm/dataManagement/${currentAppIdx}+${idx}`);
    this.setState({
      showDeleteConfirmModal: false,
      showUnsavedChangesModal: false,
      showInvalidSave: false,
      showInfoModal: false,
      // Note: failedRows/failedRowNumbers/partialSaveAllFailed/errorMessage are
      // intentionally NOT cleared here — they're kept so the toolbar warning icon
      // (lastFailureKind) can reopen this same modal later. They're cleared
      // instead on a clean save or a table switch (see saveHandler / secondaryNavClickHandler).
      showErrorModal: false,
      showPartialSaveModal: false,
      showUploadModal: false,
      importing: false,
      showProgressModal: false,
      importErrors: [],
    });
  };

  setDirty(state) {
    this.setState({ dirty: state });
  }

  gridReady(agGrid) {
    this.agGrid = agGrid;
  }

  renderInfoMessage(data) {
    if (!data) return "";
    if (typeof data === "string") return data;
    if (Array.isArray(data) && data.length > 0) {
      return data.map((item, i) => (typeof item === "object" ? JSON.stringify(item) : item)).join("\n");
    }
    return JSON.stringify(data);
  }

  getErrorCSV() {
    const { importId } = this.state;
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/mdm/getImportErrors`,
        { importId },
        { headers: { ClientToken: localStorage.getItem("clientToken") } },
      )
      .then((response) => {
        const blob = new Blob([response.data.csv], {
          type: "text/csv;charset=utf-8",
        });
        saveAs(blob, "errors.csv");
      });
  }

  renderImportDataStatus() {
    const { importErrors, importStatus } = this.state;

    if (importErrors.length === 0) {
      if (importStatus === "complete") {
        return (
          <ModalBody>
            <div>Status: {importStatus}</div>
          </ModalBody>
        );
      } else {
        return (
          <ModalBody>
            <div>Status: {importStatus}</div>
            <DotLoader size={15} color="black" loading />
          </ModalBody>
        );
      }
    } else {
      return (
        <ModalBody>
          <div>There were errors importing your data:</div>
          {importErrors.length === 1 ? (
            <div>{importErrors.length} Row had errors</div>
          ) : (
            <div>{importErrors.length} Rows had errors</div>
          )}
          <div
            onClick={() => this.getErrorCSV()}
            style={{
              color: " rgba(0, 126, 167, 1)",
              textDecoration: "underline",
              cursor: "pointer",
            }}>
            Download Error Report
          </div>
        </ModalBody>
      );
    }
  }

  renderOkButton() {
    const { importStatus } = this.state;
    if (importStatus === "complete" || importStatus === "Failed") {
      return (
        <Button color="primary" onClick={() => this.handleClose()}>
          OK
        </Button>
      );
    }
    return <Button style={{ cursor: "not-allowed" }}>OK</Button>;
  }

  onRowDataReady(gridApi) {
    // Fires whenever AG Grid finishes processing a rowData change — including the
    // refetch that follows a partial save. If a partial save is waiting on that
    // refetch to settle (see saveHandler), this is the first point where the grid
    // actually reflects it, so try to reveal the modal now.
    this.attemptPartialSaveReveal();
  }

  // Computes the partial-save modal's Row # column against the current grid, but only
  // if `this.pendingPartialSave` is still armed AND still describes the save attempt /
  // table currently on screen (see saveHandler). Called both right when a partial
  // save's refetch settles and from every subsequent onRowDataReady firing, since
  // either can be the point where the grid actually reflects the post-refetch data —
  // if a row hasn't caught up yet (getFailedRowNumber returns null for it), this
  // stays armed and waits for a later firing to try again, rather than locking in a
  // premature "—" the moment the grid happens to be mid-update. Only gives up and
  // reveals with whatever it has once every row resolves, or `pending.deadline`
  // passes (a row can legitimately never resolve — e.g. removed by a concurrent
  // change — so this can't wait forever).
  attemptPartialSaveReveal() {
    const pending = this.pendingPartialSave;
    if (!pending) return;
    if (this.unmounted || this.saveGeneration !== pending.generation || this.state.activeTableIdx !== pending.tableIdx) {
      this.pendingPartialSave = null;
      return;
    }
    const failedRowNumbers = {};
    let allResolved = true;
    pending.ids.forEach((id) => {
      const info = this.getFailedRowNumber(id);
      failedRowNumbers[id] = info;
      if (info.rowNumber === null) allResolved = false;
    });
    if (!allResolved && Date.now() < pending.deadline) return;
    this.pendingPartialSave = null;
    this.setState({
      failedRowNumbers,
      showPartialSaveModal: true,
    });
  }

  // The grid's visible "row number" (matching the row-number gutter column) for a
  // failed row's ID, so the modal can tell the user where to look instead of only
  // giving them the underlying database ID. Returns null if the grid isn't ready,
  // the row can no longer be found (e.g. it was deleted), or it's currently hidden
  // by an active filter (row numbers aren't shown for non-displayed rows).
  //
  // Called from attemptPartialSaveReveal once the post-save refetch's data has
  // actually landed in the grid (see saveHandler / onRowDataReady), so the result
  // matches what the user is about to see, rather than the pre-refetch layout the row
  // was submitted from — row positions can shift across that refetch (e.g. a
  // successfully-saved row moving out of the placeholder rows, or a now-empty
  // leading placeholder dropping out).
  // Returns { rowNumber, reason }. rowNumber is null when the row can't currently
  // be shown a Row # for one of three distinct reasons, captured in `reason` so the
  // partial-save modal can explain accurately instead of always blaming a filter:
  //   "grid-not-ready" - the grid API wasn't available when this was computed
  //   "not-found"      - no row in the grid's current data has this id (e.g. a
  //                      concurrent delete removed it) - it isn't just hidden
  //   "filtered"       - the row exists but an active filter is hiding it
  getFailedRowNumber(id) {
    if (id === null || id === undefined) return { rowNumber: null, reason: null };
    const gridApi = this.agGrid?.current?.gridApi;
    if (!gridApi) return { rowNumber: null, reason: "grid-not-ready" };
    let matchedNode = null;
    gridApi.forEachNode((node) => {
      if (!matchedNode && node.data && String(node.data.ID) === String(id)) {
        matchedNode = node;
      }
    });
    if (!matchedNode) return { rowNumber: null, reason: "not-found" };
    if (matchedNode.rowIndex === null || matchedNode.rowIndex === undefined) {
      return { rowNumber: null, reason: "filtered" };
    }
    return { rowNumber: matchedNode.rowIndex + 1, reason: null };
  }

  render() {
    const {
      currentTable,
      showDeleteConfirmModal,
      showUnsavedChangesModal,
      showInfoModal,
      showErrorModal,
      errorMessage,
      showPartialSaveModal,
      failedRows,
      failedRowNumbers,
      partialSaveAllFailed,
      showInvalidSave,
      showUploadModal,
      showProgressModal,
    } = this.state;

    const { loadingConfig, loadedConfig, error } = this.props;

    // If still loading the config or an error occurred
    if (loadingConfig || (!loadedConfig && error !== null)) {
      return <LoadingIndicator paddingTop="227px" />;
    } else if (error) {
      return <div>{error}</div>;
    }

    return (
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Progress Modal for Imports */}
        <Modal isOpen={showProgressModal}>
          <ModalHeader>Importing Data</ModalHeader>
          {this.renderImportDataStatus()}
          <ModalFooter>{this.renderOkButton()}</ModalFooter>
        </Modal>

        {/* File Upload Modal */}
        <Modal isOpen={showUploadModal}>
          <ModalHeader>Upload File</ModalHeader>
          <ModalBody>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div>
                Import files must use an export from the current table. Column headers and row IDs must be present in the
                uploaded XLSX file.
              </div>
              <div style={{ marginTop: "20px" }}>Select a XLSX import file</div>
              <div>
                <input
                  id="files"
                  type="file"
                  name="Upload"
                  onChange={this.handleselectedFile}
                  onClick={(e) => {
                    e.target.value = null;
                  }}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.uploadFile} disabled={this.state.importing}>
              {this.state.importing ? "Importing…" : "Import Data"}
            </Button>
            <Button onClick={this.handleClose}>Cancel</Button>
          </ModalFooter>
        </Modal>

        {/* Invalid Save Modal */}
        <Modal isOpen={showInvalidSave}>
          <ModalHeader>Save Error</ModalHeader>
          <ModalBody>
            <div>There are some invalid entries (in red) and this table cannot be saved. Fix these issues and try again.</div>
          </ModalBody>
          <ModalFooter>
            <Button onClick={this.handleClose}>Close</Button>
          </ModalFooter>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal isOpen={showDeleteConfirmModal}>
          <ModalHeader>Delete Row</ModalHeader>
          <ModalBody>
            <div>Are you sure you want to delete the selected row? This cannot be undone.</div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => {
                this.agGrid.current.checkRemove();
              }}>
              Delete
            </Button>
            <Button onClick={this.handleClose}>Cancel</Button>
          </ModalFooter>
        </Modal>

        {/* Info Modal */}
        <Modal isOpen={showInfoModal}>
          <ModalHeader>Info</ModalHeader>
          <ModalBody>{this.renderInfoMessage()}</ModalBody>
          <ModalFooter>
            <Button onClick={this.handleClose}>Ok</Button>
          </ModalFooter>
        </Modal>

        {/* Unsaved Changes Modal */}
        <Modal isOpen={showUnsavedChangesModal}>
          <ModalHeader>Unsaved Changes</ModalHeader>
          <ModalBody>
            <div>
              You have unsaved changes. These changes will be lost if you navigate away from this table. Do you want to
              continue?
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => {
                this.cancelHandler(true);
              }}>
              Yes
            </Button>
            <Button onClick={this.handleClose}>No</Button>
          </ModalFooter>
        </Modal>

        {/* Partial Save Modal — some rows saved, others were rejected by the server */}
        <Modal style={{ maxWidth: "80%" }} isOpen={showPartialSaveModal}>
          <ModalHeader>Some Rows Were Not Saved</ModalHeader>
          <ModalBody>
            <div style={{ marginBottom: "10px" }}>
              {partialSaveAllFailed ? (
                <>
                  None of your changes were saved. The {failedRows.length} row
                  {failedRows.length === 1 ? "" : "s"} below {failedRows.length === 1 ? "was" : "were"} rejected and{" "}
                  {failedRows.length === 1 ? "remains" : "remain"} in the table with your unsaved edits. You'll find{" "}
                  {failedRows.length === 1 ? "it" : "them"} highlighted in the grid. Fix and save again, or reload the
                  table to discard {failedRows.length === 1 ? "the change" : "these changes"}:
                </>
              ) : (
                <>
                  Your changes were saved, except for the {failedRows.length} row
                  {failedRows.length === 1 ? "" : "s"} below, which {failedRows.length === 1 ? "was" : "were"} rejected
                  and {failedRows.length === 1 ? "remains" : "remain"} in the table with your unsaved edits. You'll
                  find {failedRows.length === 1 ? "it" : "them"} highlighted in the grid. Fix and save again, or
                  reload the table to discard {failedRows.length === 1 ? "the change" : "these changes"}:
                </>
              )}
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
              <thead>
                <tr>
                  <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "4px 8px", whiteSpace: "nowrap" }}>
                    Row #
                  </th>
                  <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "4px 8px" }}>Row ID</th>
                  <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "4px 8px" }}>Action</th>
                  <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "4px 8px" }}>Reason</th>
                  <th style={{ textAlign: "left", borderBottom: "1px solid #ccc", padding: "4px 8px" }}>Row details</th>
                </tr>
              </thead>
              <tbody>
                {failedRows.map((row, idx) => {
                  const rowNumberInfo = failedRowNumbers ? failedRowNumbers[row.id] : null;
                  return (
                    <tr key={idx}>
                      <td style={{ padding: "4px 8px" }}>{rowNumberInfo?.rowNumber ?? "—"}</td>
                      <td style={{ padding: "4px 8px", whiteSpace: "nowrap" }}>
                        {row.id == null ? "(new row)" : row.action === "insert" ? `${row.id} (new row)` : row.id}
                      </td>
                      <td style={{ padding: "4px 8px" }}>{row.action}</td>
                      <td style={{ padding: "4px 8px" }}>{row.reason}</td>
                      <td style={{ padding: "4px 8px" }}>{row.keyInfo || ""}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {(() => {
              // A missing Row # has three distinct causes (see getFailedRowNumber) that
              // aren't interchangeable - e.g. blaming "hidden by a filter" when a row was
              // actually removed by a concurrent change sends the user hunting for a row
              // that no longer exists. Show only the explanation(s) that actually apply.
              const missingRowNumberMessages = {
                filtered: "Rows without a Row # may be hidden by an active filter — clear filters to locate them.",
                "not-found":
                  "Rows without a Row # are no longer present in the table (e.g. removed by a concurrent change) and can't be located.",
                "grid-not-ready": "Row numbers weren't available when this was calculated.",
              };
              const reasonsPresent = [
                ...new Set(
                  failedRows
                    .filter((row) => row.id != null)
                    .map((row) => (failedRowNumbers ? failedRowNumbers[row.id]?.reason : null))
                    .filter(Boolean),
                ),
              ];
              if (reasonsPresent.length === 0) return null;
              return (
                <div style={{ marginTop: "8px", fontStyle: "italic", color: "#888" }}>
                  {reasonsPresent.map((reason) => (
                    <div key={reason}>{missingRowNumberMessages[reason]}</div>
                  ))}
                </div>
              );
            })()}
          </ModalBody>
          <ModalFooter>
            <Button onClick={this.handleClose}>OK</Button>
          </ModalFooter>
        </Modal>

        {/* Error Modal */}
        <Modal style={{ maxWidth: "80%", maxHeight: "50%" }} isOpen={showErrorModal}>
          <ModalHeader>Error</ModalHeader>
          <ModalBody>
            <div>{errorMessage}</div>
          </ModalBody>
          <ModalFooter>
            <Button onClick={this.handleClose}>OK</Button>
          </ModalFooter>
        </Modal>

        {/* Top/Left Nav bars */}
        {this.renderSecondaryNav()}

        {/* The actual data grid container that uses React Query */}
        <DMGridContainer
          setDirty={this.setDirty}
          removeRows={this.removeRows}
          currentTable={currentTable}
          activeIdx={this.state.activeTableIdx}
          mdmConfig={this.props.mdmConfig}
          parentGridReady={this.gridReady}
          onRowDataReady={this.onRowDataReady}
          highlightedRowIds={this.state.highlightedRowIds}
          lastId={this.props.lastId}
          currentAppIdx={this.state.currentAppIdx}
          externalFilter={this.state.externalFilter}
          setExternalFilter={(filter) => this.props.setExternalFilter(filter)}
          setRefresh={(status) => this.props.setRefresh(status)}
          refresh={this.props.refresh}
          actions={this.props.actions}
          lastRunAction={this.props.lastRunAction}
          // addNewRow={row => this.props.addNewRow(row)}
          history={this.props.history}
          saveClearKey={this.state.saveClearKey}
          onProgressUpdate={(loaded, total, isLoading) => {
            this.setState({ loadedRows: loaded, rowCount: total, isLoading });
          }}
          onClearQuickFilters={this.handleClearQuickFiltersRef}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  mdmConfig: state.mdm.mdmConfig,
  mdmApps: state.mdm.mdmApps,
  loadingConfig: state.mdm.loadingConfig,
  loadedConfig: state.mdm.loadedConfig,
  loadedHydratedConfig: state.mdm.loadedHydratedConfig,
  loadedData: state.mdm.loadedData,
  loadingData: state.mdm.loadingData,
  actions: state.mdm.actions,
  lastRunAction: state.mdm.lastRunAction,

  refresh: state.mdm.refresh,
  loadingAppendData: state.mdm.loadingAppendData,
  nextRowToLoad: state.mdm.nextRowToLoad,
  rowCount: state.mdm.rowCount,
  lastId: state.mdm.lastId,
  error: state.mdm.error,
  data: state.mdm.data,
  info: state.mdm.info,
  externalFilter: state.mdm.externalFilter,
  errorMessage: state.mdm.errorMessage,
  rollBackData: state.mdm.rollBackData,
  fullLoad: state.mdm.fullLoad,
  tabs: state.topLevelNav.tabs,
  apps: state.app.apps,
});

const mapDispatchToProps = (dispatch) => ({
  addTabToNav(tab) {
    dispatch(addTabToNav(tab));
  },
  getMdmConfig(appId, projectId, signal) {
    dispatch(getMdmConfig(appId, projectId, signal));
  },
  hydrateMdmConfig(appId, signal) {
    dispatch(hydrateMdmConfig(appId, signal));
  },
  clearMdmConfig() {
    dispatch(clearMdmConfig());
  },

  // addNewRow(row) {
  //   dispatch(addNewRow(row));
  // },
  removeRows(rows) {
    dispatch(removeRows(rows));
  },
  setMdmData(data) {
    dispatch(setMdmData(data));
  },
  getActions(table) {
    dispatch(getActions(table));
  },
  setFullLoad(status) {
    dispatch(setFullLoad(status));
  },
  setRefresh(status) {
    dispatch(setRefresh(status));
  },
  resetInfo() {
    dispatch(resetInfo());
  },
  resetError() {
    dispatch(resetError());
  },
  setExternalFilter(filter) {
    dispatch(setExternalFilter(filter));
  },
  setLoadedData(status) {
    dispatch(setLoadedData(status));
  },
  doSetErrorDialog(message) {
    dispatch(doSetErrorDialog(message));
  },
  doSetInfoDialog(message) {
    dispatch(doSetInfoDialog(message));
  },
  updateLovValues(lovs) {
    dispatch(updateLovValues(lovs));
  },
  updateActionRun(actionId, lastRunTime, lastRunBy) {
    dispatch(updateActionRun(actionId, lastRunTime, lastRunBy));
  },
  updateTableRowCount: (tableIdx, newCount) => dispatch(updateTableRowCount(tableIdx, newCount)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataManagement));
